"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2922],{

/***/ 2922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ asg_page_back_drop_AsgPageBackDrop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./core/hooks/useWidthResize.ts
var useWidthResize = __webpack_require__(4546);
;// CONCATENATED MODULE: ./components/widgets/asg-page-back-drop/AsgPageBackDrop.tsx





var AsgPageBackDrop = function(props) {
    var ref, ref1;
    var app = (0,contexts_app/* useApp */.qD)();
    var width = (0,useWidthResize/* useWidth */.z)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "asg-page-backdrop ".concat(width <= 768 && 'mobile'),
        style: {
            backgroundImage: "url(".concat(utils/* path.asset */.E.asset(app.environment, width > 768 ? (ref = props.image) === null || ref === void 0 ? void 0 : ref.src : ((ref1 = props.mobileImage) === null || ref1 === void 0 ? void 0 : ref1.src) || ''), ")")
        }
    }));
};
/* harmony default export */ var asg_page_back_drop_AsgPageBackDrop = (AsgPageBackDrop);

;// CONCATENATED MODULE: ./components/widgets/asg-page-back-drop/index.tsx



/***/ })

}]);